// Eslatmalar / Reminders (pages/Reminders, and the quick action on the student page): the business
// invites its own students to a course and reminds them to pay or to study, by hand or on its own.
const reminders = {
  en: {
    title: 'Reminders',
    subtitle: 'Invite people to a course and remind them to pay or to study',
    tabs: {
      label: 'Reminders sections',
      compose: 'New message',
      history: 'History',
      rules: 'Automatic',
    },
    channel: {
      IN_APP: 'In the app',
      PUSH: 'Push',
      TELEGRAM: 'Telegram',
      SMS: 'SMS',
      EMAIL: 'Email',
    },
    channels: {
      title: 'Channels',
      alwaysOn: 'Always on',
      notConfigured: 'Not configured',
      hint: {
        IN_APP: 'The bell and the notifications page',
        PUSH: 'Phone and browser notification',
        TELEGRAM: 'Only people who linked the Darsly bot',
        SMS: 'Paid, for every part of the message',
        EMAIL: 'Only people who have an email',
      },
      smsFallback: 'SMS only if no other channel reaches',
      smsFallbackHint: 'Nobody who got Telegram or push gets an SMS too',
    },
    audience: {
      title: 'Who gets it',
      NO_COURSE: 'No course',
      UNPAID: 'Not paid',
      NOT_STARTED: 'Not started',
      INACTIVE: 'Inactive',
      SELECTED: 'Selected',
      hint: {
        NO_COURSE: 'Signed up, but has no course yet',
        UNPAID: 'Placed an order in the last 14 days and did not pay',
        NOT_STARTED: 'Enrolled 2 or more days ago and has not opened a lesson',
        INACTIVE: 'Started a course, but has not opened a lesson for a while',
        SELECTED: 'Picked by hand',
      },
      inactiveFor: 'Not studied for',
      days: '{days} days',
      course: 'Course',
      courseAll: 'All courses',
    },
    preview: {
      recipients: 'Recipients',
      reach: 'How many people each channel reaches',
      sample: 'First people on the list',
      refresh: 'Refresh',
      more: 'and {count} more',
      emptyTitle: 'Nobody matches right now',
      emptyDesc: 'Pick another group or another course',
      loadError: 'Could not load the list of people',
      col: {
        person: 'Student',
        course: 'Course',
        reason: 'Why',
      },
      reason: {
        NO_COURSE: 'No course yet',
        UNPAID: 'Payment is pending',
        NOT_STARTED: 'Has not started',
        INACTIVE: 'No lessons for {days} days',
        SELECTED: 'Picked by hand',
      },
    },
    message: {
      title: 'Message',
      titleLabel: 'Title',
      titlePlaceholder: 'For example: Welcome back...',
      titleHint: 'Only your team sees it, in the history',
      textLabel: 'Message text',
      placeholder: 'Write the message...',
      insert: 'Insert',
      ph: {
        name: "The person's first name",
        course: 'The course title',
        link: 'The link to the course (clicks are counted)',
        code: 'The promo code',
      },
      smsNote: 'An SMS longer than 160 Latin characters is billed as several parts.',
      reset: 'Back to the standard text',
      preview: 'How the message will read',
      previewEmpty: 'The message appears here as you write it',
    },
    link: {
      course: 'Link to course',
      automatic: 'Automatic',
      courseHint: "Left automatic, the link opens each person's own course (or the catalogue)",
      courseGone: 'A course that is no longer available',
      promo: 'Promo code (optional)',
      noPromo: 'No promo code',
      promoHint: 'Added to the end of the text when it has no {code}',
      promoGone: 'A promo code that no longer works',
    },
    sample: {
      name: 'Aziza',
      course: 'Russian A1',
    },
    compose: {
      titleRequired: 'Enter a title',
      messageRequired: 'Write the message',
      whenTitle: 'When',
      sendNow: 'Send now',
      schedule: 'Schedule',
      now: 'Now',
      dateAndTime: 'Date and time',
      date: 'Date',
      time: 'Time',
      dateRequired: 'Pick the date',
      timePassed: 'This time has already passed',
      tashkentTime: 'Tashkent time',
      held: 'Nothing is sent outside 09:00–21:00 Tashkent time: push, Telegram, SMS and email go out at 09:00.',
      summary: 'Summary',
      nobody: 'Nobody to send to: pick another group',
      sentToast: 'The message is being sent',
      scheduledToast: 'The message is scheduled for {when}',
      sendError: 'Could not send the message',
    },
    confirm: {
      sendTitle: 'Send to {count} person?',
      sendTitle_plural: 'Send to {count} people?',
      scheduleTitle: 'Schedule for {count} person?',
      scheduleTitle_plural: 'Schedule for {count} people?',
      send: 'Send',
      descNow: 'The message goes out now: {channels}.',
      descLater: 'The message goes out on {when}: {channels}.',
      descHeld: 'Nothing is sent outside 09:00–21:00 Tashkent time, so the message goes out on {when}: {channels}.',
    },
    status: {
      SCHEDULED: 'Scheduled',
      SENDING: 'Sending',
      SENT: 'Sent',
      CANCELLED: 'Cancelled',
      FAILED: 'Failed',
    },
    delivery: {
      SENT: 'Sent',
      FAILED: 'Failed',
      SKIPPED: 'Skipped',
    },
    history: {
      title: 'Sent and scheduled messages',
      newMessage: 'New message',
      refresh: 'Refresh',
      emptyTitle: 'No messages yet',
      emptyDesc: 'The messages you send or schedule show up here with their results.',
      loadError: 'Could not load the history',
      by: 'Author: {name}',
      col: {
        campaign: 'Message',
        channels: 'Channels',
        status: 'Status',
        recipients: 'People',
        sent: 'Sent',
        opened: 'Opened',
        converted: 'Conversion',
        date: 'Date',
        author: 'Author',
      },
    },
    detail: {
      notFoundTitle: 'Message not found',
      notFoundDesc: 'It was deleted or belongs to another business.',
      loadError: 'Could not load the message',
      goesOut: 'Goes out {when}',
      cancel: 'Cancel sending',
      cancelTitle: 'Cancel this message?',
      cancelDesc: 'It has not been sent yet. Nobody will get it.',
      cancelConfirm: 'Cancel the message',
      keep: 'Keep it',
      cancelled: 'The message was cancelled',
      cancelError: 'Could not cancel the message',
      byChannel: 'By channel',
      deliveries: 'Deliveries',
      noDeliveries: 'Nothing was delivered',
      noDeliveriesYet: 'Nothing is sent yet',
      showMore: 'Show {count} more',
      failedHint: 'Failed: {count}',
      rate: '{percent} of the people',
      smsFallback: 'Only when other channels did not reach',
      smsAlways: 'To everyone',
      converted: {
        enrolled: 'Enrolled',
        returned: 'Back to lessons',
      },
      col: {
        person: 'Person',
        channel: 'Channel',
        status: 'Status',
        sentAt: 'Sent',
        openedAt: 'Opened',
      },
    },
    rules: {
      title: 'Automatic reminders',
      subtitle: 'The server sends these on its own. Each one can be switched off and its text changed.',
      caps: 'Each reminder reaches a person only once. A person gets at most 1 reminder a day and 3 a week, and only between 09:00 and 21:00 Tashkent time.',
      on: 'On',
      off: 'Off',
      edit: 'Edit',
      editTitle: 'Edit the reminder',
      save: 'Save',
      cancel: 'Cancel',
      saved: 'Saved',
      saveError: 'Could not save the change',
      loadError: 'Could not load the automatic reminders',
      last30: 'Last 30 days',
      sent: 'Sent',
      opened: 'Opened',
      converted: {
        enrolled: 'Enrolled',
        returned: 'Back to lessons',
      },
      items: {
        NO_COURSE_1D: {
          title: '1 day since sign-up, still no course',
          desc: 'Welcomes the new student and asks them to pick a first course.',
          when: '1 day after sign-up',
        },
        NO_COURSE_3D: {
          title: '3 days since sign-up, still no course',
          desc: 'Reminds them that now is the best time to start learning.',
          when: '3 days after sign-up',
        },
        NO_COURSE_7D: {
          title: '7 days since sign-up, still no course',
          desc: 'Invites them to begin with a course.',
          when: '7 days after sign-up',
        },
        UNPAID_1H: {
          title: 'Order placed 1 hour ago, not paid',
          desc: 'Reminds them that enrolling is completed by paying.',
          when: '1 hour after the order',
        },
        UNPAID_24H: {
          title: 'Order placed 24 hours ago, not paid',
          desc: 'Says the course is still waiting and asks them to finish the payment.',
          when: '24 hours after the order',
        },
        NOT_STARTED_2D: {
          title: 'Enrolled 2 days ago, has not started',
          desc: 'Says the first lesson is ready and asks them to begin.',
          when: '2 days after enrolling',
        },
        INACTIVE_3D: {
          title: 'No lessons for 3 days',
          desc: 'Reminds them that it is time to continue the course.',
          when: '3 days after the last lesson',
        },
        INACTIVE_7D: {
          title: 'No lessons for 7 days',
          desc: 'Says a week has passed and the course is waiting.',
          when: '7 days after the last lesson',
        },
        INACTIVE_14D: {
          title: 'No lessons for 14 days',
          desc: 'Asks them not to give up the course.',
          when: '14 days after the last lesson',
        },
      },
    },
    student: {
      action: 'Send a reminder',
      historyTitle: 'Reminder history',
      empty: 'No reminders have been sent to this person yet',
      showAll: 'Show all',
      showLess: 'Show less',
      loadError: 'Could not load the reminders',
      retry: 'Try again',
      opened: 'Opened',
      automatic: 'Automatic reminder',
      untitled: 'Reminder',
    },
    quick: {
      title: 'Send a reminder',
      forPerson: 'To {name}',
      autoTitle: 'Reminder: {name}',
      send: 'Send',
      cancel: 'Cancel',
    },
  },
  ru: {
    title: 'Напоминания',
    subtitle: 'Приглашайте на курс и напоминайте об оплате и занятиях',
    tabs: {
      label: 'Разделы напоминаний',
      compose: 'Новое сообщение',
      history: 'История',
      rules: 'Автоматические',
    },
    channel: {
      IN_APP: 'В приложении',
      PUSH: 'Push',
      TELEGRAM: 'Telegram',
      SMS: 'SMS',
      EMAIL: 'Email',
    },
    channels: {
      title: 'Каналы',
      alwaysOn: 'Всегда включено',
      notConfigured: 'Не настроено',
      hint: {
        IN_APP: 'Колокольчик и страница уведомлений',
        PUSH: 'Уведомление на телефоне и в браузере',
        TELEGRAM: 'Только тем, кто подключил бота Darsly',
        SMS: 'Платно, за каждую часть сообщения',
        EMAIL: 'Только тем, у кого есть email',
      },
      smsFallback: 'SMS только если другие каналы не дошли',
      smsFallbackHint: 'Тем, кто получил Telegram или push, SMS не отправляется',
    },
    audience: {
      title: 'Кому',
      NO_COURSE: 'Без курса',
      UNPAID: 'Не оплатили',
      NOT_STARTED: 'Не начали',
      INACTIVE: 'Неактивные',
      SELECTED: 'Выбранные',
      hint: {
        NO_COURSE: 'Зарегистрировались, но у них ещё нет курса',
        UNPAID: 'Оформили заказ за последние 14 дней и не оплатили',
        NOT_STARTED: 'Записались 2 дня назад или раньше и не открывали ни одного урока',
        INACTIVE: 'Начали курс, но давно не заходили на уроки',
        SELECTED: 'Выбраны вручную',
      },
      inactiveFor: 'Не занимались',
      days: '{days} дн.',
      course: 'Курс',
      courseAll: 'Все курсы',
    },
    preview: {
      recipients: 'Получатели',
      reach: 'Сколько человек охватывает каждый канал',
      sample: 'Первые в списке',
      refresh: 'Обновить',
      more: 'и ещё {count}',
      emptyTitle: 'Сейчас никто не подходит',
      emptyDesc: 'Выберите другую группу или другой курс',
      loadError: 'Не удалось загрузить список',
      col: {
        person: 'Студент',
        course: 'Курс',
        reason: 'Причина',
      },
      reason: {
        NO_COURSE: 'Курса пока нет',
        UNPAID: 'Ждёт оплаты',
        NOT_STARTED: 'Не начал занятия',
        INACTIVE: 'Нет уроков {days} дн.',
        SELECTED: 'Выбран вручную',
      },
    },
    message: {
      title: 'Сообщение',
      titleLabel: 'Заголовок',
      titlePlaceholder: 'Например: Приглашение на курс...',
      titleHint: 'Видно только вашей команде, в истории',
      textLabel: 'Текст сообщения',
      placeholder: 'Напишите сообщение...',
      insert: 'Вставить',
      ph: {
        name: 'Имя человека',
        course: 'Название курса',
        link: 'Ссылка на курс (переходы считаются)',
        code: 'Промокод',
      },
      smsNote: 'SMS длиннее 160 латинских символов оплачивается как несколько частей.',
      reset: 'Вернуть стандартный текст',
      preview: 'Как будет выглядеть сообщение',
      previewEmpty: 'Сообщение появится здесь, пока вы его пишете',
    },
    link: {
      course: 'Ссылка на курс',
      automatic: 'Автоматически',
      courseHint: 'При автоматическом выборе ссылка ведёт на курс самого человека (или в каталог)',
      courseGone: 'Курс, которого больше нет',
      promo: 'Промокод (необязательно)',
      noPromo: 'Без промокода',
      promoHint: 'Добавляется в конец текста, если в нём нет {code}',
      promoGone: 'Промокод, который больше не действует',
    },
    sample: {
      name: 'Азиза',
      course: 'Русский A1',
    },
    compose: {
      titleRequired: 'Введите заголовок',
      messageRequired: 'Напишите текст сообщения',
      whenTitle: 'Когда',
      sendNow: 'Отправить сейчас',
      schedule: 'Запланировать',
      now: 'Сейчас',
      dateAndTime: 'Дата и время',
      date: 'Дата',
      time: 'Время',
      dateRequired: 'Выберите дату',
      timePassed: 'Это время уже прошло',
      tashkentTime: 'По ташкентскому времени',
      held: 'Вне 09:00–21:00 по Ташкенту сообщения не отправляются: push, Telegram, SMS и email уйдут в 09:00.',
      summary: 'Итог',
      nobody: 'Некому отправлять: выберите другую группу',
      sentToast: 'Сообщение отправляется',
      scheduledToast: 'Сообщение запланировано на {when}',
      sendError: 'Не удалось отправить сообщение',
    },
    confirm: {
      sendTitle: 'Отправить {count} человеку?',
      sendTitle_few: 'Отправить {count} людям?',
      sendTitle_plural: 'Отправить {count} людям?',
      scheduleTitle: 'Запланировать для {count} человека?',
      scheduleTitle_few: 'Запланировать для {count} человек?',
      scheduleTitle_plural: 'Запланировать для {count} человек?',
      send: 'Отправить',
      descNow: 'Сообщение будет отправлено сейчас: {channels}.',
      descLater: 'Сообщение будет отправлено {when}: {channels}.',
      descHeld: 'Вне 09:00–21:00 по Ташкенту сообщения не отправляются, поэтому оно уйдёт {when}: {channels}.',
    },
    status: {
      SCHEDULED: 'Запланировано',
      SENDING: 'Отправляется',
      SENT: 'Отправлено',
      CANCELLED: 'Отменено',
      FAILED: 'Ошибка',
    },
    delivery: {
      SENT: 'Отправлено',
      FAILED: 'Ошибка',
      SKIPPED: 'Пропущено',
    },
    history: {
      title: 'Отправленные и запланированные сообщения',
      newMessage: 'Новое сообщение',
      refresh: 'Обновить',
      emptyTitle: 'Сообщений пока нет',
      emptyDesc: 'Отправленные и запланированные сообщения появятся здесь вместе с результатами.',
      loadError: 'Не удалось загрузить историю',
      by: 'Автор: {name}',
      col: {
        campaign: 'Сообщение',
        channels: 'Каналы',
        status: 'Статус',
        recipients: 'Получатели',
        sent: 'Отправлено',
        opened: 'Открыли',
        converted: 'Конверсия',
        date: 'Дата',
        author: 'Автор',
      },
    },
    detail: {
      notFoundTitle: 'Сообщение не найдено',
      notFoundDesc: 'Оно удалено или принадлежит другому бизнесу.',
      loadError: 'Не удалось загрузить сообщение',
      goesOut: 'Уйдёт {when}',
      cancel: 'Отменить отправку',
      cancelTitle: 'Отменить это сообщение?',
      cancelDesc: 'Оно ещё не отправлено. Никто его не получит.',
      cancelConfirm: 'Отменить сообщение',
      keep: 'Оставить',
      cancelled: 'Сообщение отменено',
      cancelError: 'Не удалось отменить сообщение',
      byChannel: 'По каналам',
      deliveries: 'Доставки',
      noDeliveries: 'Ничего не доставлено',
      noDeliveriesYet: 'Пока ничего не отправлено',
      showMore: 'Показать ещё {count}',
      failedHint: 'Ошибок: {count}',
      rate: '{percent} от получателей',
      smsFallback: 'Только если другие каналы не дошли',
      smsAlways: 'Всем',
      converted: {
        enrolled: 'Записались',
        returned: 'Вернулись к урокам',
      },
      col: {
        person: 'Человек',
        channel: 'Канал',
        status: 'Статус',
        sentAt: 'Отправлено',
        openedAt: 'Открыто',
      },
    },
    rules: {
      title: 'Автоматические напоминания',
      subtitle: 'Сервер отправляет их сам. Каждое можно выключить и изменить его текст.',
      caps: 'Каждое напоминание доходит до человека только один раз. Один человек получает не больше 1 напоминания в день и 3 в неделю, и только с 09:00 до 21:00 по Ташкенту.',
      on: 'Включено',
      off: 'Выключено',
      edit: 'Изменить',
      editTitle: 'Изменить напоминание',
      save: 'Сохранить',
      cancel: 'Отмена',
      saved: 'Сохранено',
      saveError: 'Не удалось сохранить изменение',
      loadError: 'Не удалось загрузить автоматические напоминания',
      last30: 'Последние 30 дней',
      sent: 'Отправлено',
      opened: 'Открыли',
      converted: {
        enrolled: 'Записались',
        returned: 'Вернулись к урокам',
      },
      items: {
        NO_COURSE_1D: {
          title: 'Прошёл 1 день после регистрации, курса нет',
          desc: 'Приветствует нового студента и предлагает выбрать первый курс.',
          when: 'Через 1 день после регистрации',
        },
        NO_COURSE_3D: {
          title: 'Прошло 3 дня после регистрации, курса нет',
          desc: 'Напоминает, что сейчас лучшее время начать учиться.',
          when: 'Через 3 дня после регистрации',
        },
        NO_COURSE_7D: {
          title: 'Прошло 7 дней после регистрации, курса нет',
          desc: 'Приглашает начать с курса.',
          when: 'Через 7 дней после регистрации',
        },
        UNPAID_1H: {
          title: 'Заказ оформлен 1 час назад, не оплачен',
          desc: 'Напоминает, что запись на курс завершается оплатой.',
          when: 'Через 1 час после заказа',
        },
        UNPAID_24H: {
          title: 'Заказ оформлен 24 часа назад, не оплачен',
          desc: 'Говорит, что курс ждёт, и просит завершить оплату.',
          when: 'Через 24 часа после заказа',
        },
        NOT_STARTED_2D: {
          title: 'Записался 2 дня назад, не начал занятия',
          desc: 'Сообщает, что первый урок готов, и предлагает начать.',
          when: 'Через 2 дня после записи',
        },
        INACTIVE_3D: {
          title: '3 дня без уроков',
          desc: 'Напоминает, что пора продолжить курс.',
          when: 'Через 3 дня после последнего урока',
        },
        INACTIVE_7D: {
          title: '7 дней без уроков',
          desc: 'Говорит, что прошла неделя и курс ждёт.',
          when: 'Через 7 дней после последнего урока',
        },
        INACTIVE_14D: {
          title: '14 дней без уроков',
          desc: 'Просит не бросать курс.',
          when: 'Через 14 дней после последнего урока',
        },
      },
    },
    student: {
      action: 'Отправить напоминание',
      historyTitle: 'История напоминаний',
      empty: 'Этому человеку ещё не отправляли напоминаний',
      showAll: 'Показать все',
      showLess: 'Свернуть',
      loadError: 'Не удалось загрузить напоминания',
      retry: 'Повторить',
      opened: 'Открыто',
      automatic: 'Автоматическое напоминание',
      untitled: 'Напоминание',
    },
    quick: {
      title: 'Отправить напоминание',
      forPerson: 'Для: {name}',
      autoTitle: 'Напоминание: {name}',
      send: 'Отправить',
      cancel: 'Отмена',
    },
  },
  uz: {
    title: 'Eslatmalar',
    subtitle: "O'quvchilarni kursga taklif qiling, to'lov va darsni eslatib turing",
    tabs: {
      label: "Eslatmalar bo'limlari",
      compose: 'Yangi xabar',
      history: 'Tarix',
      rules: 'Avtomatik',
    },
    channel: {
      IN_APP: 'Ilova ichida',
      PUSH: 'Push',
      TELEGRAM: 'Telegram',
      SMS: 'SMS',
      EMAIL: 'Email',
    },
    channels: {
      title: 'Kanallar',
      alwaysOn: 'Doim yoqilgan',
      notConfigured: 'Sozlanmagan',
      hint: {
        IN_APP: "Qo'ng'iroqcha va bildirishnomalar sahifasi",
        PUSH: 'Telefon va brauzer bildirishnomasi',
        TELEGRAM: 'Faqat Darsly botini ulaganlarga',
        SMS: "Pullik, xabarning har bir qismi uchun",
        EMAIL: 'Faqat emaili borlarga',
      },
      smsFallback: 'SMS faqat boshqa kanal yetmasa',
      smsFallbackHint: 'Telegram yoki push yetib borgan odamga SMS yuborilmaydi',
    },
    audience: {
      title: 'Kimga',
      NO_COURSE: "Kursi yo'qlar",
      UNPAID: "To'lamaganlar",
      NOT_STARTED: 'Boshlamaganlar',
      INACTIVE: 'Faol emaslar',
      SELECTED: 'Tanlanganlar',
      hint: {
        NO_COURSE: "Ro'yxatdan o'tgan, lekin hali kursi yo'q",
        UNPAID: "Oxirgi 14 kunda buyurtma bergan, lekin to'lamagan",
        NOT_STARTED: "2 kun yoki undan oldin kursga yozilgan, lekin birorta dars ochmagan",
        INACTIVE: 'Kursni boshlagan, lekin darsga uzoq vaqtdan beri kirmagan',
        SELECTED: "Qo'lda tanlangan",
      },
      inactiveFor: 'Darsga kirmaganiga',
      days: '{days} kun',
      course: 'Kurs',
      courseAll: 'Barcha kurslar',
    },
    preview: {
      recipients: 'Qabul qiluvchilar',
      reach: 'Har bir kanal nechta odamga yetadi',
      sample: "Ro'yxatdagi birinchi odamlar",
      refresh: 'Yangilash',
      more: 'yana {count} ta',
      emptyTitle: 'Hozircha hech kim mos kelmaydi',
      emptyDesc: 'Boshqa guruh yoki boshqa kursni tanlang',
      loadError: "Odamlar ro'yxatini yuklab bo'lmadi",
      col: {
        person: "O'quvchi",
        course: 'Kurs',
        reason: 'Sabab',
      },
      reason: {
        NO_COURSE: "Kursi hali yo'q",
        UNPAID: "To'lov kutilmoqda",
        NOT_STARTED: 'Darsni boshlamagan',
        INACTIVE: '{days} kundan beri darsga kirmagan',
        SELECTED: "Qo'lda tanlangan",
      },
    },
    message: {
      title: 'Xabar',
      titleLabel: 'Sarlavha',
      titlePlaceholder: 'Masalan: Kursga taklif...',
      titleHint: "Faqat sizning jamoangiz tarixda ko'radi",
      textLabel: 'Xabar matni',
      placeholder: 'Xabarni yozing...',
      insert: "Qo'shish",
      ph: {
        name: 'Odamning ismi',
        course: 'Kurs nomi',
        link: 'Kursga havola (bosishlar sanaladi)',
        code: 'Promokod',
      },
      smsNote: "160 ta lotin belgisidan uzun SMS bir necha qism sifatida hisoblanadi va har bir qismi alohida to'lanadi.",
      reset: 'Standart matnga qaytarish',
      preview: "Xabar shunday ko'rinadi",
      previewEmpty: "Yozgan sari xabar shu yerda ko'rinadi",
    },
    link: {
      course: 'Kurs havolasi',
      automatic: 'Avtomatik',
      courseHint: "Avtomatik bo'lsa, havola har bir odamning o'z kursini (yoki kurslar ro'yxatini) ochadi",
      courseGone: "Mavjud bo'lmagan kurs",
      promo: 'Promokod (ixtiyoriy)',
      noPromo: 'Promokodsiz',
      promoHint: "Matnda {code} bo'lmasa, matn oxiriga qo'shiladi",
      promoGone: 'Endi ishlamaydigan promokod',
    },
    sample: {
      name: 'Aziza',
      course: 'Rus tili A1',
    },
    compose: {
      titleRequired: 'Sarlavhani kiriting',
      messageRequired: 'Xabar matnini yozing',
      whenTitle: 'Qachon',
      sendNow: 'Hozir yuborish',
      schedule: 'Rejalashtirish',
      now: 'Hozir',
      dateAndTime: 'Sana va vaqt',
      date: 'Sana',
      time: 'Vaqt',
      dateRequired: 'Sanani tanlang',
      timePassed: "Bu vaqt o'tib ketgan",
      tashkentTime: 'Toshkent vaqti bilan',
      held: "09:00–21:00 (Toshkent vaqti) dan tashqarida xabar yuborilmaydi: Push, Telegram, SMS va Email soat 09:00 da ketadi.",
      summary: 'Xulosa',
      nobody: "Yuboriladigan odam yo'q: boshqa guruhni tanlang",
      sentToast: 'Xabar yuborilmoqda',
      scheduledToast: 'Xabar {when} ga rejalashtirildi',
      sendError: "Xabarni yuborib bo'lmadi",
    },
    confirm: {
      sendTitle: "{count} ta odamga yuborilsinmi?",
      sendTitle_plural: "{count} ta odamga yuborilsinmi?",
      scheduleTitle: "{count} ta odamga rejalashtirilsinmi?",
      scheduleTitle_plural: "{count} ta odamga rejalashtirilsinmi?",
      send: 'Yuborish',
      descNow: 'Xabar hozir yuboriladi: {channels}.',
      descLater: 'Xabar {when} da yuboriladi: {channels}.',
      descHeld: "09:00–21:00 (Toshkent vaqti) dan tashqarida xabar yuborilmaydi, shuning uchun u {when} da ketadi: {channels}.",
    },
    status: {
      SCHEDULED: 'Rejalashtirilgan',
      SENDING: 'Yuborilmoqda',
      SENT: 'Yuborildi',
      CANCELLED: 'Bekor qilingan',
      FAILED: 'Xato',
    },
    delivery: {
      SENT: 'Yuborildi',
      FAILED: 'Xato',
      SKIPPED: "O'tkazib yuborildi",
    },
    history: {
      title: 'Yuborilgan va rejalashtirilgan xabarlar',
      newMessage: 'Yangi xabar',
      refresh: 'Yangilash',
      emptyTitle: "Hali xabar yuborilmagan",
      emptyDesc: "Yuborgan va rejalashtirgan xabarlaringiz natijalari bilan shu yerda ko'rinadi.",
      loadError: "Tarixni yuklab bo'lmadi",
      by: 'Muallif: {name}',
      col: {
        campaign: 'Xabar',
        channels: 'Kanallar',
        status: 'Holat',
        recipients: 'Qabul qiluvchilar',
        sent: 'Yuborildi',
        opened: 'Ochildi',
        converted: 'Konversiya',
        date: 'Sana',
        author: 'Muallif',
      },
    },
    detail: {
      notFoundTitle: 'Xabar topilmadi',
      notFoundDesc: "U o'chirilgan yoki boshqa biznesga tegishli.",
      loadError: "Xabarni yuklab bo'lmadi",
      goesOut: '{when} da yuboriladi',
      cancel: 'Yuborishni bekor qilish',
      cancelTitle: 'Xabar bekor qilinsinmi?',
      cancelDesc: 'U hali yuborilmagan. Hech kim olmaydi.',
      cancelConfirm: 'Xabarni bekor qilish',
      keep: 'Qoldirish',
      cancelled: 'Xabar bekor qilindi',
      cancelError: "Xabarni bekor qilib bo'lmadi",
      byChannel: "Kanallar bo'yicha",
      deliveries: 'Yetkazib berish',
      noDeliveries: 'Hech narsa yetkazilmadi',
      noDeliveriesYet: 'Hali hech narsa yuborilmagan',
      showMore: "Yana {count} ta ko'rsatish",
      failedHint: 'Xato: {count} ta',
      rate: '{percent} qabul qiluvchilardan',
      smsFallback: 'Faqat boshqa kanal yetmaganda',
      smsAlways: 'Hammaga',
      converted: {
        enrolled: 'Kursga yozildi',
        returned: 'Darsga qaytdi',
      },
      col: {
        person: 'Odam',
        channel: 'Kanal',
        status: 'Holat',
        sentAt: 'Yuborildi',
        openedAt: 'Ochildi',
      },
    },
    rules: {
      title: 'Avtomatik eslatmalar',
      subtitle: "Bularni server o'zi yuboradi. Har birini o'chirib qo'yish va matnini o'zgartirish mumkin.",
      caps: "Har bir eslatma bir odamga faqat bir marta yuboriladi. Bir odamga kuniga ko'pi bilan 1 ta, haftada 3 ta eslatma ketadi, faqat 09:00–21:00 oralig'ida (Toshkent vaqti).",
      on: 'Yoqilgan',
      off: "O'chirilgan",
      edit: 'Tahrirlash',
      editTitle: 'Eslatmani tahrirlash',
      save: 'Saqlash',
      cancel: 'Bekor qilish',
      saved: 'Saqlandi',
      saveError: "O'zgarishni saqlab bo'lmadi",
      loadError: "Avtomatik eslatmalarni yuklab bo'lmadi",
      last30: 'Oxirgi 30 kun',
      sent: 'Yuborildi',
      opened: 'Ochildi',
      converted: {
        enrolled: 'Kursga yozildi',
        returned: 'Darsga qaytdi',
      },
      items: {
        NO_COURSE_1D: {
          title: "Ro'yxatdan o'tganiga 1 kun bo'ldi, kursi yo'q",
          desc: "Yangi o'quvchini kutib oladi va birinchi kursni tanlashga chorlaydi.",
          when: "Ro'yxatdan o'tgandan 1 kun keyin",
        },
        NO_COURSE_3D: {
          title: "Ro'yxatdan o'tganiga 3 kun bo'ldi, kursi yo'q",
          desc: "O'qishni boshlash uchun eng yaxshi vaqt hozir ekanini eslatadi.",
          when: "Ro'yxatdan o'tgandan 3 kun keyin",
        },
        NO_COURSE_7D: {
          title: "Ro'yxatdan o'tganiga 7 kun bo'ldi, kursi yo'q",
          desc: 'Kurs bilan boshlashga taklif qiladi.',
          when: "Ro'yxatdan o'tgandan 7 kun keyin",
        },
        UNPAID_1H: {
          title: "Buyurtma 1 soat oldin berilgan, to'lanmagan",
          desc: "Kursga yozilish to'lov bilan yakunlanishini eslatadi.",
          when: 'Buyurtmadan 1 soat keyin',
        },
        UNPAID_24H: {
          title: "Buyurtma 24 soat oldin berilgan, to'lanmagan",
          desc: "Kurs kutayotganini aytib, to'lovni yakunlashni so'raydi.",
          when: 'Buyurtmadan 24 soat keyin',
        },
        NOT_STARTED_2D: {
          title: "Kursga yozilganiga 2 kun bo'ldi, darsni boshlamagan",
          desc: 'Birinchi dars tayyor ekanini aytib, boshlashga chorlaydi.',
          when: 'Kursga yozilgandan 2 kun keyin',
        },
        INACTIVE_3D: {
          title: '3 kundan beri darsga kirmagan',
          desc: 'Kursni davom ettirish vaqti kelganini eslatadi.',
          when: 'Oxirgi darsdan 3 kun keyin',
        },
        INACTIVE_7D: {
          title: '7 kundan beri darsga kirmagan',
          desc: "Bir hafta o'tganini va kurs kutayotganini aytadi.",
          when: 'Oxirgi darsdan 7 kun keyin',
        },
        INACTIVE_14D: {
          title: '14 kundan beri darsga kirmagan',
          desc: "Kursni tashlab qo'ymaslikni so'raydi.",
          when: 'Oxirgi darsdan 14 kun keyin',
        },
      },
    },
    student: {
      action: 'Eslatma yuborish',
      historyTitle: 'Eslatmalar tarixi',
      empty: 'Bu odamga hali eslatma yuborilmagan',
      showAll: "Hammasini ko'rsatish",
      showLess: "Kamroq ko'rsatish",
      loadError: "Eslatmalarni yuklab bo'lmadi",
      retry: 'Qaytadan',
      opened: 'Ochildi',
      automatic: 'Avtomatik eslatma',
      untitled: 'Eslatma',
    },
    quick: {
      title: 'Eslatma yuborish',
      forPerson: 'Kimga: {name}',
      autoTitle: 'Eslatma: {name}',
      send: 'Yuborish',
      cancel: 'Bekor qilish',
    },
  },
};

export default reminders;
